import { render, staticRenderFns } from "./XStatus.vue?vue&type=template&id=4aa1c3f8&scoped=true"
import script from "./XStatus.vue?vue&type=script&lang=js"
export * from "./XStatus.vue?vue&type=script&lang=js"
import style0 from "./XStatus.vue?vue&type=style&index=0&id=4aa1c3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa1c3f8",
  null
  
)

export default component.exports